import { useEffect, useState, useRef } from 'react';

const easeOutExpo = (t) => t === 1 ? 1 : 1 - Math.pow(2, -10 * t);

export const useCountUp = (end, start = 0, duration = 2000) => {
  const [count, setCount] = useState(start);
  const startRef = useRef(null);

  useEffect(() => {
    if (startRef.current !== null) return;
    startRef.current = performance.now();

    const animate = (timestamp) => {
      const timeElapsed = timestamp - startRef.current;
      const progress = Math.min(timeElapsed / duration, 1);
      const easedProgress = easeOutExpo(progress);

      const newCount = start + (end - start) * easedProgress;
      setCount(Math.floor(newCount));

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    requestAnimationFrame(animate);

    return () => {
      startRef.current = null;
    };
  }, [end, start, duration]);

  return count;
};